import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Space, Popconfirm, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useDeleteAnnotationComment } from '@components/annotations/hooks/useMutateAnnotation';
import { timeZoneOffsetSelector } from '@store/common/selectors';
import { StyledCommentBox, StyledDeleteButton } from '../styled';

function AnnoComment({ item, index, profile }) {
  const { createdAt, username, description, createdBy, annotationId, commentId } = item;
  const { profile_id } = profile;
  const tzOffset = useSelector(timeZoneOffsetSelector);

  const deleteComment = useDeleteAnnotationComment();

  const showPopconfirm = (annotationId, commentId) => {
    deleteComment.mutate({ annotationId, commentId });
  };

  const dateTime = moment.utc(createdAt).utcOffset(tzOffset).format('LLL');

  return (
    <StyledCommentBox>
      <Space direction="vertical">
        <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.65)' }}>
          {username} | {dateTime}
        </div>
        <div>{description}</div>
      </Space>
      {profile_id === createdBy && index !== 0 ? (
        <Popconfirm
          key="delete"
          title="Are you sure?"
          okText="Yes"
          cancelText="No"
          onConfirm={() => showPopconfirm(annotationId, commentId)}
        >
          <StyledDeleteButton>
            <Button type="text" style={{ fontSize: 12 }} icon={<DeleteOutlined />} />
          </StyledDeleteButton>
        </Popconfirm>
      ) : null}
    </StyledCommentBox>
  );
}

export default AnnoComment;
